__webpack_require__.p = "https://dev-portal-hello.denthub.ai/";